import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { RiStairsLine, RiTable3, RiSofaLine, RiDoorOpenLine, RiRectangleLine, RiSubtractLine, RiImageLine, RiAppleLine, RiShapesLine, RiCollageFill, RiGitCommitLine, RiTextSnippet, RiNavigationLine, RiRulerLine } from "react-icons/ri";
import useSceneStore from '../store/useSceneStore';
import { TOOLS, ELEMENT_TYPES } from '../core/constants';
import { clsx } from 'clsx';

const { 
  FiMousePointer, FiSearch
} = FiIcons;

const ToolbarButton = ({ active, icon, onClick, title, disabled = false }) => (
  <button 
    onClick={onClick} 
    title={title}
    disabled={disabled}
    className={clsx(
      "p-2 rounded-lg transition-colors mb-2",
      disabled ? "bg-gray-100 text-gray-400 cursor-not-allowed" :
      active ? "bg-[#1E2937] text-white shadow-md" : 
      "bg-white text-gray-600 hover:bg-gray-100 hover:text-[#1E2937]"
    )}
  >
    <SafeIcon icon={icon} className="text-xl" />
  </button>
);

const Toolbar = () => {
  const { tool, setTool } = useSceneStore();

  // Sprawdzanie czy aktywny jest jakikolwiek typ otworu
  const isOpeningActive = tool === TOOLS.OPENINGS || Object.values(ELEMENT_TYPES).includes(tool);

  return (
    <div className="absolute left-4 top-1/2 -translate-y-1/2 flex flex-col bg-white rounded-xl shadow-lg p-2 border border-gray-200 z-10 max-h-[90vh] overflow-y-auto scrollbar-hide">
      <ToolbarButton icon={FiMousePointer} active={tool === TOOLS.SELECT} onClick={() => setTool(TOOLS.SELECT)} title="Zaznacz" />
      
      <div className="h-px bg-gray-200 my-2 mx-1" />
      
      <ToolbarButton icon={RiSubtractLine} active={tool === TOOLS.WALL} onClick={() => setTool(TOOLS.WALL)} title="Ściana" />
      <ToolbarButton icon={RiRectangleLine} active={tool === TOOLS.ROOM} onClick={() => setTool(TOOLS.ROOM)} title="Pomieszczenie" />
      <ToolbarButton icon={RiGitCommitLine} active={tool === TOOLS.NODE} onClick={() => setTool(TOOLS.NODE)} title="Punkt węzłowy" />
      <ToolbarButton icon={RiCollageFill} active={tool === TOOLS.SURFACE} onClick={() => setTool(TOOLS.SURFACE)} title="Powierzchnia" />
      <ToolbarButton icon={RiTextSnippet} active={tool === TOOLS.TEXT} onClick={() => setTool(TOOLS.TEXT)} title="Tekst" />
      
      <div className="h-px bg-gray-200 my-2 mx-1" />
      
      {/* Zintegrowany przycisk Katalogu Otworów */}
      <ToolbarButton 
        icon={RiDoorOpenLine} 
        active={isOpeningActive} 
        onClick={() => setTool(TOOLS.OPENINGS)} 
        title="Drzwi i Okna" 
      />
      
      <div className="h-px bg-gray-200 my-2 mx-1" />
      
      <ToolbarButton icon={RiSofaLine} active={tool === TOOLS.FURNITURE} onClick={() => setTool(TOOLS.FURNITURE)} title="Aranżacja" />
      <ToolbarButton icon={RiStairsLine} active={tool === TOOLS.STAIRS} onClick={() => setTool(TOOLS.STAIRS)} title="Schody" />
      <ToolbarButton icon={RiNavigationLine} active={tool === TOOLS.NORTH_ARROW} onClick={() => setTool(TOOLS.NORTH_ARROW)} title="Róża wiatrów" />
      <ToolbarButton icon={RiTable3} active={tool === TOOLS.TABLE} onClick={() => setTool(TOOLS.TABLE)} title="Metryczka" />
      <ToolbarButton icon={RiShapesLine} active={tool === TOOLS.SHAPE} onClick={() => setTool(TOOLS.SHAPE)} title="Kształty" />
      <ToolbarButton icon={RiRulerLine} active={tool === TOOLS.DIMENSION_LINE} onClick={() => setTool(TOOLS.DIMENSION_LINE)} title="Linia wymiarowa" />
      <ToolbarButton icon={RiAppleLine} active={tool === 'LOGO'} onClick={() => setTool('LOGO')} title="Logotyp" />
      <ToolbarButton icon={RiImageLine} active={tool === 'BACKGROUND'} onClick={() => setTool('BACKGROUND')} title="Podkład" />
    </div>
  );
};

export default Toolbar;